module.exports = __webpack_public_path__ + "img/4PNG_Cover.3803044f.jpg";